import { render, staticRenderFns } from "./VueAvatarScale.vue?vue&type=template&id=1fcd6af2&scoped=true&"
import script from "./VueAvatarScale.vue?vue&type=script&lang=js&"
export * from "./VueAvatarScale.vue?vue&type=script&lang=js&"
import style0 from "./VueAvatarScale.vue?vue&type=style&index=0&id=1fcd6af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd6af2",
  null
  
)

export default component.exports